/* ============================================================
   HERO SOCKS THEME — Global JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Announcement bar close ──
  const announcementClose = document.querySelector('.announcement-bar__close');
  const announcementBar   = document.querySelector('.announcement-bar');
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', function () {
      announcementBar.style.display = 'none';
      sessionStorage.setItem('announcementClosed', '1');
    });
    if (sessionStorage.getItem('announcementClosed') === '1') {
      announcementBar.style.display = 'none';
    }
  }

  // ── Sticky header shadow on scroll ──
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  // ── Mobile nav toggle ──
  const hamburger  = document.querySelector('.hamburger');
  const mobileNav  = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ── Live cart count ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }
  updateCartCount();

  // ── Product page: thumbnail gallery ──
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.querySelector('img').src.replace('_72x', '_800x');
      }
    });
  });

  // ── Product page: size selector ──
  const sizeBtns = document.querySelectorAll('.size-btn');
  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sizeBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // ── Add to cart ──
  const addToCartForm = document.querySelector('[data-product-form]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(addToCartForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          updateCartCount();
          // simple feedback
          const btn = addToCartForm.querySelector('.btn-add-to-cart');
          if (btn) {
            const original = btn.textContent;
            btn.textContent = 'Added!';
            setTimeout(function () { btn.textContent = original; }, 1500);
          }
        })
        .catch(function () {
          alert('Something went wrong. Please try again.');
        });
    });
  }

});
